import React, { useState } from "react";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PrintIcon from "@mui/icons-material/Print";

// import JS files
import MuiPagination from "../../../shares/MuiPagination";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTable from "../../../shares/PanelTable";
import RemoveOrder from "./RemoveOrder";
import DeliverOrderCustomer from "./DeliverOrderCustomer";
import useFetch from "../../../../context/useFetch";
import ChangeOrderState from "./ChangeOrderState";
import { fixNumbers } from "../../../../utils";
import PrintOrderiInfo from "./PrintOrderiInfo";
import MuiButton from "../../../shares/MuiButton";
import { useNavigate } from "react-router-dom";

const headersList = [
  { colName: "unique_id", name: "سند " },
  { colName: "name", name: "مشتری" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن" },
  { colName: "factor_status", name: "وضعیت" },
  { colName: "delivery", name: "تحویل به مشتری" },
  { colName: "change_state", name: "تغییر وضعیت سفارش" },
  { colName: "print", name: "چاپ سفارش" },
  // { colName: "remove", name: "لغو سفارش" },
];
const dataKey = ["unique_id", "name", "created_at", "total", "factor_status"];

const mobileHeadersList = [
  { colName: "unique_id", name: " سند" },
  { colName: "name", name: "مشتری" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن" },
  { colName: "factor_status", name: "وضعیت" },
];

const TabOne = (props) => {
  const [citiesList, setCitiesList] = useState({ results: [] });
  const navigate = useNavigate();
  const [cityPaginationPageInfo, setCityPaginationPageInfo] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
  });

  const getCitiesApi = useFetch({
    method: "get",
    url: "City_Service",
    trigger: true,
    pagination: cityPaginationPageInfo,
    setter: setCitiesList,
    argFunc: (res) => {
      setCityPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const [codeFilter, setCodeFilter] = useState(null);
  const [dateFilter, setDateFilter] = useState(null);
  const [storeFilter, setStoreFilter] = useState(null);
  const [cityFilter, setCityFilter] = useState(null);

  const [isFilterOn, setIsFilterOn] = useState(false);

  const filterList = [
    {
      type: "textField",
      label_fa: "سند",
      label_en: "code",
      state: codeFilter,
    },
    {
      type: "textField",
      label_fa: "نام مشتری",
      label_en: "storeName",
      state: storeFilter,
    },
    {
      type: "datePicker",
      label_fa: "تاریخ ثبت سفارش",
      label_en: "date",
      state: dateFilter,
    },
    {
      type: "select",
      label_fa: "شهر",
      label_en: "city",
      state: cityFilter,
      menuItems: citiesList.results,
      fromApi: true,
    },
  ];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 1000,
    count: 0,
  });
  const [currentOerdersList, setCurrentOerdersList] = useState({ results: [] });

  const adminGetCustomerCurrentOrderApi = useFetch({
    method: "get",
    url: `Order_Service/admin_get_onprogress_order`,
    params: {
      unique_id: fixNumbers(codeFilter),
      date: dateFilter,
      store_name: storeFilter,
      city:
        cityFilter !== "all"
          ? cityFilter !== null && cityFilter !== "all"
            ? citiesList.results.filter((it) => it.id == cityFilter)[0].name
            : cityFilter
          : undefined,
    },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setCurrentOerdersList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
      rowsWeightSum(res.results);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "date") setDateFilter(e.length > 0 ? e : null);
    if (state == "storeName") setStoreFilter(e.length > 0 ? e : null);
    if (state == "city") setCityFilter(e);
  };

  const filter = () => {
    if (
      codeFilter !== null ||
      dateFilter !== null ||
      storeFilter !== null ||
      cityFilter !== null
    ) {
      setCurrentOerdersList({ results: [] });

      setIsFilterOn(true);
      adminGetCustomerCurrentOrderApi.reFetch();
    }
  };
  const reset_filter = () => {
    setCodeFilter(null);
    setDateFilter(null);
    setStoreFilter(null);
    setCityFilter(null);
    adminGetCustomerCurrentOrderApi.reFetch();
  };

  const actionsList = [
    {
      label: "تغییر وضعیت سفارش",
      component: (it) => (
        <ChangeOrderState
          selectedRow={it}
          adminGetCustomerCurrentOrderApi={adminGetCustomerCurrentOrderApi}
        />
      ),
    },
    {
      label: "چاپ",
      component: (it) => <PrintOrderiInfo selectedRow={it} />,
    },
    // {
    //   label: "لغو سفارش",
    //   component: (it) => (
    //     <RemoveOrder
    //       selectedRow={it}
    //       adminGetCustomerCurrentOrderApi={adminGetCustomerCurrentOrderApi}
    //     />
    //   ),
    // },
  ];
  const buttonsList = [
    {
      label: "تحویل به مشتری",
      component: (it) => (
        <DeliverOrderCustomer
          RemoveOrder
          selectedRow={it}
          adminGetCustomerCurrentOrderApi={adminGetCustomerCurrentOrderApi}
        />
      ),
    },
  ];

  const [weightSum, setWeightSum] = useState(0);
  const [weightSumRed, setWeightSumRed] = useState(0);
  const [weightSumGreen, setWeightSumGreen] = useState(0);
  const rowsWeightSum = (res) => {
    let sum = 0;
    let sum_red = 0;
    let sum_green = 0;
    for (let index = 0; index < res.length; index++) {
      sum = sum + parseFloat(res[index].total);
      sum_red = sum_red + parseFloat(res[index].total_red);
      sum_green = sum_green + parseFloat(res[index].total_green);
    }
    setWeightSum(sum);
    setWeightSumRed(sum_red);
    setWeightSumGreen(sum_green);
  };

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setCurrentOerdersList({ results: [] });
    adminGetCustomerCurrentOrderApi.reFetch();
  };
  const handelPrintReport = () => {
    // navigate(
    //   `/print-customers-current-orders-by-customer/${codeFilter}/${storeFilter}/${dateFilter}/${cityFilter}`
    // );
    window.open(
      `/print-customers-current-orders-by-customer/${codeFilter}/${storeFilter}/${dateFilter}/${cityFilter}`,
      "_blank"
      // "rel=noopener noreferrer"
    );
  };
  return (
    <>
      <PanelFilter
        header="فیلتر سفارش‌ها:"
        list={filterList}
        update_filter={update_filter}
        filter={filter}
        reset_filter={reset_filter}
      />
      <div className="flex justify-end">
        <MuiButton
          onClick={handelPrintReport}
          variant="outlined"
          icon={<PrintIcon />}
          color="primary"
          text="چاپ گزارش"
          margin="mr-2"
        />
      </div>
      <PanelTable
        header="لیست سفارش‌های جاری براساس مشتری:"
        headers={headersList}
        mobileHeaders={mobileHeadersList}
        data={currentOerdersList.results}
        dataKey={dataKey}
        buttons={buttonsList}
        actions={actionsList}
        icon={<AccountBalanceIcon />}
      />
      <div className="border py-2 text-sm text-myblue-100 font-bold">
        <div className="flex items-center">
          <div className="mx-6">
            <span className="">جمع وزن کل:</span>
            <span className="mr-4">{weightSum.toFixed(3)} گرم</span>
          </div>
          <div className="mx-6">
            <span className="">جمع تحویلی:</span>
            <span className="mr-4">{weightSumGreen.toFixed(3)} گرم</span>
          </div>
          <div>
            <span className="">جمع کسری:</span>
            <span className="mr-4">{weightSumRed.toFixed(3)} گرم</span>
          </div>
        </div>
      </div>
      <MuiPagination
        onChange={onChangePage}
        count={Math.ceil(
          paginationPageInfo.count / paginationPageInfo.pageSize
        )}
      />
    </>
  );
};

export default TabOne;
